/**
 * @description 所有产品的 URL 地址的映射表
 */

/**
 * app 相关
 */

const BASE_URL = ''
/** app 页面地址汇总 */
export const appPageUrls = {
  home: `${BASE_URL}/`,
  logs: `${BASE_URL}/admin/log`,
  locationDashboard: `${BASE_URL}/admin/location`,
  timelineImages: `${BASE_URL}/admin/timeline-images`,
  scanImages: `${BASE_URL}/admin/scan-images`,
  trackPoints: `${BASE_URL}/admin/trackpoints`,
  trackPoints3D: `${BASE_URL}/admin/trackpoints-3d`,
  revenueCat: `${BASE_URL}/admin/revenuecat`,
  usage: `${BASE_URL}/admin/usage`,
} as const

/** app API 地址汇总 */
export const appApiUrls = {
  // auth
  auth: {
    check: '/api/auth/check',
    login: '/api/auth/login',
    logout: '/api/auth/logout',
  },
  // app
  locationChart: '/api/location/chart',
  locationRegeocodeAmap: '/api/location/regeocode-amap',
  locationRegeocodeGmap: '/api/location/regeocode-gmap',
  locationMapLocations: '/api/location/map-locations',
  timelineImage: {
    list: '/api/timeline-image/list',
    stats: '/api/timeline-image/stats',
    file: (imageId: string) => `/api/timeline-image/file/${imageId}`,
  },
  scanImage: {
    list: '/api/scan-image/list',
    file: (id: string) => `/api/scan-image/file/${id}`,
  },
  lifetimeFootprint: {
    list: '/api/lifetime-footprint/list',
    file: (id: string) => `/api/lifetime-footprint/file/${id}`,
  },
  testflightDiagnostics: {
    list: '/api/testflight-diagnostics/list',
    file: (id: string) => `/api/testflight-diagnostics/file/${id}`,
  },
  revenueCatProxyLogs: '/api/revenuecat-proxy/logs',
  revenueCatClientSignals: '/api/revenuecat-proxy/client-signals',
  usageDashboard: '/api/usage/dashboard',
  appUrl: 'https://apps.apple.com/app/6481981341',
} as const
